import React from 'react';
import heroimg from '../assets/images/guy.png';
import NavBar from './nav';
import { MdPhone } from 'react-icons/md';
import Navbar3 from './navbar';


function Hero() {
    return (
        <div className="bg-hero-color text-white pt-20 px-10 md:px-12 lg:px-20 w-full md:max-w-8xl rounded-2xl items-center md:mx-4 mt-6">

            {/* <NavBar /> */}
            <Navbar3 />

            {/* Hero section */}
            <div className="container mx-auto flex flex-col md:flex-row items-end justify-center">
                {/* Left column with text */}
                <div className="w-full md:w-11/20 md:pr-4 pb-10">
                    <div className="text-center md:text-left">
                        <h1 className="text-3xl md:text-6xl font-bold mb-4 md:mb-8 text-custom-color">You Have a Problem? <br /> We'll Help You Fix it</h1>
                        <p className="text-sm md:text-xl mb-4 md:mb-8 text-gray-900">Our Support Center is Always Available For Assistance</p>
                    </div>
                    <div className="bg-white text-sm flex items-center justify-between rounded-full p-1 md:w-[60%]">
                        <input
                            type="text"
                            className="text-gray-900 bg-transparent border-none focus:outline-none md:py-4 md:pl-6 md:pr-2 md:pr-6 w-full md:w-[20vw] md:text-lg text-xs" // Added pr-2 and w-full
                            placeholder="What Service Are you Looking For"
                        />

                        {/* <button className="bg-custom-color hover:bg-gray-900 text-white text-sm md:text-base font-bold py-2 md:py-3 px-6 md:px-12 flex items-center rounded-full">
                            <MdPhone className='mr-2' size={25} color="white" />
                            Call Center
                        </button> */}

                        <div className='bg-black flex gap-x-2 items-center justify-center py-3 px-4 rounded-full text-white text-xs md:text-md font-semibold'>
                            <MdPhone size={25} />
                            <p>Call Center</p>
                        </div>
                    </div>

                </div>
                {/* Right column with image */}
                <div className="md:w-9/20 md:pl-4 pb-0 md:pt-10">
                    <img src={heroimg} alt="Your Image" className="rounded-lg shadow-lg w-4/5 h-auto" />
                </div>
            </div>
        </div>
    );
}

export default Hero;
